module.exports = __webpack_public_path__ + "img/banner.48147639.png";